
import {
  DeploymentUnitOutlined,
  LoginOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
} from '@ant-design/icons-vue';
import { useToggle } from '@bigo/vue-use';
import { Dropdown, Layout, Menu, Modal, Spin } from 'ant-design-vue';
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import businessDict from '@/store/business-dict';
import loginInfoStore from '@/store/login-info';
import showMessage from '@/utils/show-message';

import NestableMenuItem from './components/NestableMenuItem.vue';
import useMenu from './compositions/use-menu';

export default defineComponent({
  components: {
    'a-spin': Spin,
    'a-layout': Layout,
    'a-layout-sider': Layout.Sider,
    'a-layout-header': Layout.Header,
    'a-layout-content': Layout.Content,
    'a-menu': Menu,
    'a-menu-item': Menu.Item,
    'a-dropdown': Dropdown,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    LoginOutlined,
    DeploymentUnitOutlined,
    NestableMenuItem,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const [collapsed, onToggle] = useToggle(false);
    const [menu, onMenuSelect] = useMenu();

    const loading = ref(true);
    const username = computed(() => loginInfoStore.casName || loginInfoStore.casId);

    onMounted(async () => {
      try {
        await loginInfoStore.load();
        await businessDict.load();
      } catch (error) {
        showMessage(error, { 200001: '请登录' });
        return;
      }

      // 没有菜单权限时，跳转到首页
      const matched = route.matched[1];
      if (!loginInfoStore.permission.includes(matched.name as string)) {
        router.replace({ name: 'home' });
      }

      loading.value = false;
    });

    const onLogout = () => {
      Modal.confirm({
        content: '确认退出登录？',
        onOk: () => {
          const callback = window.encodeURIComponent(window.location.href);
          window.location.href = `${process.env.VUE_APP_API_HOST}/logout?callback=${callback}`;
        },
      });
    };

    return { loading, username, collapsed, onToggle, menu, onMenuSelect, onLogout };
  },
});
